// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Icon, PropTypes } from '@plesk/ui-library';

const SkinIcon = ({ src, ...props }, { config }) => {
    const { version, skinUrl } = config;

    if (src.indexOf('/') === 0) {
        src = src.slice(1);
    }

    return (
        <Icon src={`${skinUrl}${src}?${version}`} {...props} />
    );
};

SkinIcon.propTypes = {
    src: PropTypes.string.isRequired,
};

SkinIcon.contextTypes = {
    config: PropTypes.object,
};

export default SkinIcon;



// WEBPACK FOOTER //
// ./plesk/SkinIcon.js